import { css } from 'linaria';

export const productDescription = css`
  && {
    width: 877px;
    margin-bottom: 40px;

    @media (--from-tablet) and (--to-largeDesktop) {
      margin-bottom: 24px;
    }

    @media (--to-desktop) {
      width: 100%;
    }

    @media (--only-mobile) {
      margin-bottom: 0;
    }
  }
`;

export const productDescriptionText = css`
  min-height: 96px;

  @media (--only-tablet) {
    min-height: 120px;
  }

  @media (--only-mobile) {
    min-height: 137px;
  }

  p {
    padding: 0;
    margin: 0;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: var(--text-primary);

    &:last-child {
      margin-top: 16px;
    }
  }

  ul {
    padding: 0;
    list-style: none;

    li:not(:last-child) {
      margin-bottom: 8px;
    }
  }

  span {
    display: block;
    margin-top: 16px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: var(--text-minor);
  }

  span:not(:last-child) {
    display: block;
    margin-top: 24px;
    margin-bottom: 16px;
    font-weight: 500;
    font-size: 20px;
    line-height: 26px;
    color: var(--text-primary);
  }
`;
